import { render, staticRenderFns } from "./BookingnoPaxDetails.vue?vue&type=template&id=8df03114&scoped=true"
import script from "./BookingnoPaxDetails.vue?vue&type=script&lang=js"
export * from "./BookingnoPaxDetails.vue?vue&type=script&lang=js"
import style0 from "./BookingnoPaxDetails.vue?vue&type=style&index=0&id=8df03114&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df03114",
  null
  
)

export default component.exports